import { render, staticRenderFns } from "./ssorderList.vue?vue&type=template&id=2b3a5f24&"
import script from "./ssorderList.vue?vue&type=script&lang=js&"
export * from "./ssorderList.vue?vue&type=script&lang=js&"
import style0 from "./ssorderList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports